import {
	SET_HAS_CAMERA_PERMISSION,
	CLEAR_SCAN,
	SET_SCANNED_DATA,
	HIDE_QR_CODE_SCANNER_MODAL,
	SHOW_QR_CODE_SCANNER_MODAL
} from "../actions/types";

import { PWA_DEEPLINK_APP_URL, DEEPLINK_URL_SCHEME } from "../config/constants";

const initialState = {
	hasCameraPermission: null,
	scanned: false,
	isUnknownDeepLink: false,
	showQrCodeScannerModal: false,
	link: null
};

// Extract a Branch.io Quick Link's `$deeplink_path` query param, if present.
// Returned as an app-relative path (leading "/"), e.g.
// "https://app.hapicolibri.fr/register?$deeplink_path=paris-11%2Fconnexion%3Fregisterkey%3DWELCOME24"
// -> "/paris-11/connexion?registerkey=WELCOME24".
const extractBranchDeeplinkPath = url => {
	const match = url.match(/[?&]\$deeplink_path=([^&#]+)/);
	if (!match) {
		return null;
	}
	try {
		const path = decodeURIComponent(match[1]);
		return path.startsWith("/") ? path : `/${path}`;
	} catch (e) {
		return null;
	}
};

export default function urlscanReducer(state = initialState, action = {}) {
	switch (action.type) {
		case HIDE_QR_CODE_SCANNER_MODAL:
			return {
				...state,
				showQrCodeScannerModal: false
			};

		case SHOW_QR_CODE_SCANNER_MODAL:
			return {
				...state,
				// Reset on every opening so the CameraView only mounts once this
				// opening's permission check has resolved. Otherwise, from the second
				// opening on, it mounted right away and its getUserMedia raced the
				// permission request's own getUserMedia: on Android Chrome the camera
				// then failed to start and the scanner stayed black.
				hasCameraPermission: null,
				scanned: false,
				isUnknownDeepLink: false,
				showQrCodeScannerModal: true
			};

		case CLEAR_SCAN:
			return {
				...state,
				scanned: false,
				isUnknownDeepLink: false,
				link: null
			};

		case SET_HAS_CAMERA_PERMISSION:
			return {
				...state,
				hasCameraPermission: action.payload
			};

		case SET_SCANNED_DATA:
			const { data: url } = action.payload;
			if (!url) {
				return {
					...state,
					scanned: true,
					isUnknownDeepLink: true
				};
			}
			// Branch.io Quick Link: any URL carrying a $deeplink_path query param.
			// Community-join QR codes now go through Branch, so we recognise them
			// regardless of the host and hand the scan pipeline the same relative
			// path a PWA/scheme URL would produce.
			const branchPath = extractBranchDeeplinkPath(url);
			if (branchPath) {
				return {
					...state,
					scanned: true,
					link: branchPath,
					showQrCodeScannerModal: false
				};
			}
			if (
				!url.startsWith(PWA_DEEPLINK_APP_URL) &&
				!url.startsWith(DEEPLINK_URL_SCHEME)
			) {
				return {
					...state,
					scanned: true,
					isUnknownDeepLink: true
				};
			} else if (url.startsWith(PWA_DEEPLINK_APP_URL)) {
				const link = url.substring(PWA_DEEPLINK_APP_URL.length);
				return {
					...state,
					scanned: true,
					link: link ? link : "/",
					showQrCodeScannerModal: false
				};
			} else {
				const link = url.substring(DEEPLINK_URL_SCHEME.length);

				return {
					...state,
					scanned: true,
					link: link ? link : "/",
					showQrCodeScannerModal: false
				};
			}

		default:
			return state;
	}
}
